import PropTypes from 'prop-types';
import { useState } from 'react';
import Surface from './ui/Surface';
import { classNames } from '../utils/classNames';

export default function Disclosure({ title, children, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <Surface className="p-6 md:p-8">
      <button
        type="button"
        className="flex w-full items-center justify-between text-left text-base font-semibold text-cam-blue"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
      >
        <span>{title}</span>
        <span className="text-2xl text-cam-blue" aria-hidden="true">
          {open ? '−' : '+'}
        </span>
      </button>
      <div className={classNames('mt-4 text-sm text-slate-600', open ? 'block' : 'hidden')}>
        {children}
      </div>
    </Surface>
  );
}

Disclosure.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  defaultOpen: PropTypes.bool
};
